import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import socials from "../../data/socials";

const ContactInfoOne = () => {
    return (
      <div className="bk_contact_classic bg_color--1 ptb--160 ptb-md--80 ptb-sm--80">
          <Container>
              <Row>
                  {data.map(item=>(
                    <Col key={item.id} md={6} lg={4} className="wow move-up">
                        <div className="classic-address text-center">
                            <h4 className="heading heading-h4" style={{fontFamily: "Montserrat"}}>{item.title}</h4>
                            <div className="desc mt--15">
                                <p className="bk_pra line-height-2-22" dangerouslySetInnerHTML={{__html: item.content}}/>
                            </div>
                        </div>
                    </Col>
                  ))}
                  <Col md={6} lg={4} className="wow move-up">
                      <div className="classic-address text-center">
                          <h4 className="heading heading-h4" style={{fontFamily: "Montserrat"}}>Follow us</h4>
                          <div className="desc mt--15">
                              <ul className="social-icon icon-solid-rounded icon-size-medium text-center move-up wow">
                                  {socials.map(social => (
                                    <li className={social.media}>
                                        <a target="_blank" rel="noopener noreferrer" key={social.id} href={social.link}>
                                            <i className={`fa fa-${social.media}`}/>
                                        </a>
                                    </li>
                                  ))}
                              </ul>
                          </div>
                      </div>
                  </Col>
              </Row>
          </Container>
      </div>
    );
};

const data = [
    {
        id: 1,
        title: "Visit our office at",
        content: "Pharmacore Technology and Innovation, Sdn. Bhd. <br/>Suite 7.01 & 7.02 Level 7 <br/>The Gardens North Tower, <br/>No. 35 Lingkaran Syed Putra, <br/>Mid Valley City, Kuala Lumpur, <br/>Wilayah Persekutuan 59200, Malaysia"
    },
    {
        id:2,
        title:"Contact",
        content: "+603-27386582 <br/>paragon.malaysia@paracorpgroup.com"
    }
]

export default ContactInfoOne;
